import yup from '~/utils/validation';

export const signInFormSchema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required(),
});
